module.exports = __webpack_public_path__ + "resources/img/main02_jp_m.4b3901d35af40af34b8d314a59a5290e.png";